import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserRole } from '../models/user';
import { normalizeUserRoles } from '../utils/authorization.util';

@Pipe({ name: 'userRoles', standalone: true, pure: false })
export class UserRolesPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(roles: UserRole | string | Array<UserRole | string | null | undefined> | null | undefined): string {
    const normalizedRoles = normalizeUserRoles(roles);
    const visibleRoles = normalizedRoles.length > 1
      ? normalizedRoles.filter((role) => role !== UserRole.USER)
      : normalizedRoles;

    return visibleRoles
      .map((role) => this.translateService.instant(role))
      .join(', ');
  }
}
